<div [formGroup]="form()">
  <ct-lib-info-banner>
    <p>
      {{
        (recommendationsPaused()
          ? 'jobboard.platform.settings.notifications.paused-info'
          : 'jobboard.platform.settings.notifications.info'
        ) | transloco
      }}
    </p>
  </ct-lib-info-banner>
  <div class="ct-switch-wrapper p-3 disabled" aria-disabled="true">
    <div class="copy">
      <p>{{ 'jobboard.platform.settings.notifications.application-invitation' | transloco }}</p>
      <span class="hint">{{
        'jobboard.platform.settings.notifications.application-invitation-hint' | transloco
      }}</span>
    </div>
    <div class="switch">
      <input
        type="checkbox"
        class="ct-switch"
        id="settingsNotifyApplicationInvitation"
        checked
        disabled
      />
      <label for="settingsNotifyApplicationInvitation"></label>
    </div>
  </div>
  <div
    class="ct-switch-wrapper p-3"
    [class.disabled]="recommendationsPaused()"
    (click)="!recommendationsPaused() && talentpoolCheckbox.click()"
  >
    <div class="copy">
      <p>{{ 'jobboard.platform.settings.notifications.talentpool-invitation' | transloco }}</p>
      <span class="hint">{{
        'jobboard.platform.settings.notifications.talentpool-invitation-hint' | transloco
      }}</span>
    </div>
    <div class="switch" (click)="$event.stopPropagation()">
      <input
        type="checkbox"
        class="ct-switch"
        id="settingsNotifyTalentpoolInvitation"
        formControlName="notifyTalentpoolInvitation"
        #talentpoolCheckbox
      />
      <label for="settingsNotifyTalentpoolInvitation"></label>
    </div>
  </div>
  <div
    class="ct-switch-wrapper p-3"
    [class.disabled]="recommendationsPaused()"
    (click)="!recommendationsPaused() && recommendationCheckbox.click()"
  >
    <div class="copy">
      <p>{{ 'jobboard.platform.settings.notifications.job-recommendation' | transloco }}</p>
      <span class="hint">{{
        'jobboard.platform.settings.notifications.job-recommendation-hint' | transloco
      }}</span>
    </div>
    <div class="switch" (click)="$event.stopPropagation()">
      <input
        type="checkbox"
        class="ct-switch"
        id="settingsNotifyJobRecommendation"
        formControlName="notifyJobRecommendation"
        #recommendationCheckbox
      />
      <label for="settingsNotifyJobRecommendation"></label>
    </div>
  </div>
  <div
    class="ct-switch-wrapper p-3"
    [class.disabled]="recommendationsPaused()"
    (click)="!recommendationsPaused() && statusCheckbox.click()"
  >
    <div class="copy">
      <p>{{ 'jobboard.platform.settings.notifications.application-status' | transloco }}</p>
      <span class="hint">{{
        'jobboard.platform.settings.notifications.application-status-hint' | transloco
      }}</span>
    </div>
    <div class="switch" (click)="$event.stopPropagation()">
      <input
        type="checkbox"
        class="ct-switch"
        id="settingsNotifyApplicationStatus"
        formControlName="notifyApplicationStatus"
        #statusCheckbox
      />
      <label for="settingsNotifyApplicationStatus"></label>
    </div>
  </div>
</div>
